import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "product-wrapper"
};
const _hoisted_2 = {
  class: "product-page"
};
const _hoisted_3 = {
  class: "content-wrapper"
};
const _hoisted_4 = {
  class: "side-menu"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  key: 0,
  class: "right-content"
};
const _hoisted_7 = {
  class: "product-list"
};
const _hoisted_8 = {
  key: 0,
  class: "product-image"
};
const _hoisted_9 = ["src", "alt"];
const _hoisted_10 = {
  class: "product-info"
};
const _hoisted_11 = {
  class: "product-name"
};
const _hoisted_12 = {
  key: 0,
  class: "product-intro"
};
const _hoisted_13 = {
  key: 1,
  class: "product-params"
};
const _hoisted_14 = {
  class: "params-text"
};
const _hoisted_15 = {
  class: "product-time"
};
const _hoisted_16 = {
  key: 0,
  class: "pagination-wrapper"
};
const _hoisted_17 = {
  key: 1,
  class: "right-content loading-content"
};
const _hoisted_18 = {
  key: 2,
  class: "right-content empty-content"
};
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { getCategoryList, getProductListByCid } from '@/api/product';
export default /*@__PURE__*/_defineComponent({
  __name: 'Product',
  setup(__props) {
    const route = useRoute();
    // 分类列表
    const categoryList = ref([]);
    // 当前选中的分类ID
    const activeCategoryId = ref(null);
    // 产品列表
    const productList = ref([]);
    // 加载状态
    const loading = ref(true);
    // 分页相关
    const currentPage = ref(1);
    const pageSize = ref(1);
    const total = ref(0);
    const totalPages = ref(0);
    // 获取分类列表
    const fetchCategoryList = async () => {
      try {
        const res = await getCategoryList();
        if (res.data && res.data.length > 0) {
          categoryList.value = res.data;
          // 检查 URL 参数中是否有 cid
          const cidFromQuery = route.query.cid;
          if (cidFromQuery) {
            const targetCategory = res.data.find(cat => cat.id === Number(cidFromQuery));
            if (targetCategory) {
              handleSelectCategory(targetCategory);
              return;
            }
          }
          // 如果没有 cid 参数或找不到对应分类，默认选中第一个分类
          handleSelectCategory(res.data[0]);
        }
      } catch (error) {
        console.error('获取分类列表失败:', error);
        loading.value = false;
      }
    };
    // 根据分类ID获取产品列表
    const fetchProductList = async (categoryId, page = 1) => {
      try {
        loading.value = true;
        const res = await getProductListByCid({
          pageNum: page,
          pageSize: pageSize.value,
          cid: categoryId
        });
        if (res.data) {
          productList.value = res.data;
          total.value = res.total || 0;
          totalPages.value = Math.ceil(total.value / pageSize.value);
        } else {
          productList.value = [];
          total.value = 0;
          totalPages.value = 0;
        }
      } catch (error) {
        console.error('获取产品列表失败:', error);
        productList.value = [];
        total.value = 0;
        totalPages.value = 0;
      } finally {
        loading.value = false;
      }
    };
    // 选择分类
    const handleSelectCategory = category => {
      activeCategoryId.value = category.id;
      currentPage.value = 1;
      fetchProductList(category.id, 1);
    };
    // 处理分页切换
    const handlePageChange = page => {
      fetchProductList(activeCategoryId.value, page);
      // 滚动到顶部
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    };
    // 格式化日期
    const formatDate = dateStr => {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      return `${year}年${month}月${day}日`;
    };
    // 页面加载时获取分类列表
    onMounted(() => {
      fetchCategoryList();
    });
    return (_ctx, _cache) => {
      const _component_Breadcrumb = _resolveComponent("Breadcrumb");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_Footer = _resolveComponent("Footer");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Breadcrumb, {
        items: [{
          label: '首页',
          path: '/'
        }, {
          label: '产品服务'
        }, {
          label: '产品列表'
        }]
      }), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryList.value, item => {
        return _openBlock(), _createElementBlock("div", {
          key: item.id,
          class: _normalizeClass(["menu-item", {
            active: item.id === activeCategoryId.value
          }]),
          onClick: $event => handleSelectCategory(item)
        }, _toDisplayString(item.name), 11, _hoisted_5);
      }), 128))]), productList.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productList.value, product => {
        return _openBlock(), _createElementBlock("div", {
          key: product.id,
          class: "product-item"
        }, [product.productImage ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("img", {
          src: product.productImage,
          alt: product.name
        }, null, 8, _hoisted_9)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, _toDisplayString(product.name), 1), product.introduce ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(product.introduce), 1)) : _createCommentVNode("", true), product.majorParameter ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_cache[1] || (_cache[1] = _createElementVNode("div", {
          class: "params-title"
        }, "主要参数：", -1)), _createElementVNode("div", _hoisted_14, _toDisplayString(product.majorParameter), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_15, " 发布时间：" + _toDisplayString(formatDate(product.publishTime)), 1)])]);
      }), 128))]), total.value > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createVNode(_component_el_pagination, {
        "current-page": currentPage.value,
        "onUpdate:currentPage": _cache[0] || (_cache[0] = $event => currentPage.value = $event),
        "page-size": pageSize.value,
        total: total.value,
        layout: "total, prev, pager, next, jumper",
        onCurrentChange: handlePageChange
      }, null, 8, ["current-page", "page-size", "total"])])) : _createCommentVNode("", true)])) : loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_17, [...(_cache[2] || (_cache[2] = [_createElementVNode("div", {
        class: "loading-text"
      }, "加载中...", -1)]))])) : (_openBlock(), _createElementBlock("div", _hoisted_18, [...(_cache[3] || (_cache[3] = [_createElementVNode("div", {
        class: "empty-text"
      }, "该分类暂无产品数据", -1)]))]))])]), _createVNode(_component_Footer)]);
    };
  }
});